import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

export const getTaskProgressBadgeColorClass = pct => {
  if (pct === null || pct === undefined) return '';
  if (pct >= 100) return 'task-statistics-completed';
  if (pct >= 75) return 'task-statistics-green';
  if (pct >= 50) return 'task-statistics-yellow';
  return 'task-statistics-red';
};

export const computeProgressPercentage = (data, useDuration) => {
  if (!data) return null;
  const completed = useDuration ? data.completedDurationMinutes : data.completedCount;
  const total = useDuration ? data.totalDurationMinutes : data.totalCount;
  if (!total) return null;
  return Math.round((completed / total) * 100);
};

const TaskProgressBadge = ({ percentage, title }) => {
  if (percentage === null || percentage === undefined) return null;
  const number = Math.floor(percentage);
  return (
    <span title={title} className={classNames('badge', getTaskProgressBadgeColorClass(number))}>
      {number}%
    </span>
  );
};

TaskProgressBadge.propTypes = {
  percentage: PropTypes.number,
  title: PropTypes.string,
};

TaskProgressBadge.defaultProps = {
  percentage: null,
  title: null,
};

export default TaskProgressBadge;
